__turbopack_context__.v({
  "aboutBlockContainer": "AboutBlockCS-module-scss-module__HeKRva__aboutBlockContainer",
  "aboutBlockContainerEditMode": "AboutBlockCS-module-scss-module__HeKRva__aboutBlockContainerEditMode",
  "aboutBlockContainerMessageFullWidth": "AboutBlockCS-module-scss-module__HeKRva__aboutBlockContainerMessageFullWidth",
  "blocksBackgroundColor": "AboutBlockCS-module-scss-module__HeKRva__blocksBackgroundColor",
  "blocksFontColor": "AboutBlockCS-module-scss-module__HeKRva__blocksFontColor",
  "editMediaContainer": "AboutBlockCS-module-scss-module__HeKRva__editMediaContainer",
  "messageContainer": "AboutBlockCS-module-scss-module__HeKRva__messageContainer",
  "messageTransitionContainer": "AboutBlockCS-module-scss-module__HeKRva__messageTransitionContainer",
  "secondaryNavBackgroundColor": "AboutBlockCS-module-scss-module__HeKRva__secondaryNavBackgroundColor",
  "seeMore": "AboutBlockCS-module-scss-module__HeKRva__seeMore",
  "themeBackgroundColor": "AboutBlockCS-module-scss-module__HeKRva__themeBackgroundColor",
  "themeFontColor": "AboutBlockCS-module-scss-module__HeKRva__themeFontColor",
  "titleContainer": "AboutBlockCS-module-scss-module__HeKRva__titleContainer",
  "transitionAppear": "AboutBlockCS-module-scss-module__HeKRva__transitionAppear",
  "transitionAppearActive": "AboutBlockCS-module-scss-module__HeKRva__transitionAppearActive",
  "transitionAppearDone": "AboutBlockCS-module-scss-module__HeKRva__transitionAppearDone",
  "transitionEnter": "AboutBlockCS-module-scss-module__HeKRva__transitionEnter",
  "transitionEnterActive": "AboutBlockCS-module-scss-module__HeKRva__transitionEnterActive",
  "transitionEnterDone": "AboutBlockCS-module-scss-module__HeKRva__transitionEnterDone",
  "transitionExit": "AboutBlockCS-module-scss-module__HeKRva__transitionExit",
  "transitionExitActive": "AboutBlockCS-module-scss-module__HeKRva__transitionExitActive",
  "transitionExitDone": "AboutBlockCS-module-scss-module__HeKRva__transitionExitDone",
  "videoContainer": "AboutBlockCS-module-scss-module__HeKRva__videoContainer",
  "videoTransitionContainer": "AboutBlockCS-module-scss-module__HeKRva__videoTransitionContainer",
});
